export default __webpack_public_path__ + "static/media/personal5.9c145f88.jpeg";